import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import WithRender from './UpdateMessageTemplateRequest.html';
import { Inject } from 'vue-di-container';
import UpdateMessageTemplateRequestService from './UpdateMessageTemplateRequestService';
import MessageTemplateService from '../MessageTemplateService';
import { DropdownModel } from '../../Provider/ProviderModel';
import CITCKeywordsService from '../../CITCKeywords/CITCKeywordsService';
import ProviderService from '../../Provider/ProviderService';
import { UpdateMessageTemplateModel, SenderViewModel } from './UpdateMessageTemplateModel';
import { SuggestedTemplateModel, TemplateValidationModel } from '../MessageTemplateModel';
import ValidationService from '../../../Services/ValidationService';
import UserService from '../../../shared/userService/UserService';
import UserRoleService from '../../../shared/userService/UserRoleService';
import { Toaster } from '../../../Services/toast';
import { SenderType } from '../../../shared/Enums/SenderType';
import { AttachmentModel } from '../../AddRequest/AttachmentModel';
import { AttachmentCategoryType } from '../../../shared/Enums/AttachmentCategory';
import { AxiosError } from 'axios';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        UpdateMessageTemplateRequestService,
        MessageTemplateService,
        CITCKeywordsService,
        ProviderService,
    ],
})
export default class UpdateMessageTemplateRequest extends Vue {
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UpdateMessageTemplateRequestService) public UpdateContractRequestService!: UpdateMessageTemplateRequestService;
    @Inject(MessageTemplateService) public messageTemplateService!: MessageTemplateService;
    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ default: 0 })
    public id!: string;

    public minDate: Date = new Date();
    public stepNumber: number = 1;
    public userRole: number = 0;
    public requestStatus: number = 0;
    public senderName: string = '';
    public typeFile: number = 0;
    public senderNameLength: number = 11;
    public contractAttachmentName: string = '';
    public senderType: number[] = [];
    public isVipPackage: boolean = false;
    public expiryDateFromMenu: boolean = false;
    public concatenatedSenderTypes: string = '';
    public sendersList: string[] = [];
    public submitRequestdialog: boolean = false;
    public isSubmitted: boolean = false;
    public isCriticalSender: boolean = false;
    public senderNameId: number = 0;
    public templateVariableExamples: string[] = [];
    public selectedFileName: string = '';
    public currentAttachment: AttachmentModel = {
        id: '',
        fileName: '',
        fileContent: '',
        file: null,
        attachmentType: '',
        attachmentTypeName: '',
        isDeleted: false,
    };
    public responseMessage: string = '';
    public responseSuccess: boolean = false;
    public isAiValid: boolean = false;
    public aiValidationRemarks: string = '';
    public loadingAIValidation: boolean = false;
    public aiValidationProgress: number = 0;
    private aiValidationProgressInterval: any = null;

    public readonly maxTemplateContentLength: number = 160;
    public readonly maxLicenseAttachments: number = 3;
    public readonly maxLicenseFileSizeBytes: number = 3000000;
    public readonly totalSteps: number = 2;

    private readonly noActiveRegulationMessage: string = 'No active regulation found for this category';

    public headers: any = [
        { text: this.$t('shared.senderName'), value: 'operatorId', align: 'right', sortable: false },
        { text: this.$t('shared.senderType'), value: 'operatorId', align: 'center', sortable: false },
        { text: this.$t('shared.clientName'), value: 'name', align: 'center', sortable: false }
    ];
    public customerTypeList: DropdownModel[] = [
        { id: 1, name: this.$t('shared.government').toString() },
        { id: 2, name: this.$t('shared.charity').toString() },
        { id: 3, name: this.$t('shared.private').toString() },
        { id: 4, name: this.$t('shared.international').toString() },
    ];
    public allClassifications: DropdownModel[] = [
        { id: 1, name: this.$t('shared.Advertising').toString() },
        { id: 2, name: this.$t('shared.Service').toString() },
        { id: 3, name: this.$t('shared.Warning').toString() },
        { id: 5, name: this.$t('shared.Awareness').toString() },
    ];
    public classification: DropdownModel[] = this.allClassifications;

    private readonly classificationBySenderType: { [key: number]: number[] } = {
        [SenderType.Advertisement]: [1],
        [SenderType.Service]: [2],
        [SenderType.Awareness]: [5],
        [SenderType.Warning]: [3],
    };

    public chanel: DropdownModel[] = [
        { id: 1, name: 'SMS' },
        { id: 2, name: 'Internal Shortcode' },
        { id: 3, name: 'Google RCS' },
    ];
    public templateExpiry: DropdownModel[] = [
        { id: 1, name: this.$t('shared.OneYear').toString() },
    ];
    public senderTypeList: DropdownModel[] = [
        { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
        { id: SenderType.Service, name: this.$t('shared.service').toString() },
        { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
        { id: SenderType.Warning, name: this.$t('shared.warning').toString() },
    ];

    public preApprovedTemplates: SuggestedTemplateModel[] = [];
    public loadingPreApprovedTemplates: boolean = false;
    private loadedSuggestedFreeContentSnapshot: {
        preApprovedTemplateId: string;
        selectedTemplateId: string;
        templateContent: string;
        templateDescription: string;
        templateName: string;
        templateVariableExamples: string[];
        selectedTemplateDescription: string;
    } | null = null;

    public validationModel: TemplateValidationModel = {
        TemplateContent: '',
        Classification: 0,
    };

    public model: UpdateMessageTemplateModel = {
        id: '',
        duration: '1',
        startDate: '',
        clientName: '',
        customerType: 0,
        crNumber: '',
        enterpriseUnifiedNumber: '',
        senderName: '',
        requestType: 7,
        comment: '',
        expiryDate: '',
        senderType: 0,
        isNormalProcessing: true,
        isExpressProcessing: false,
        preApprovedTemplateId: '',
        selectedTemplateId: '',
        senderId: '',
        templateContent: '',
        templateDescription: '',
        templateExpiry: 0,
        templateName: '',
        processingDuration: 0,
        classification: 0,
        chanel: 0,
        senderRequestAttachments: [],
    };

    senderNames: SenderViewModel[] = [];
    public selected: SenderViewModel[] = [];
    public selectedIds: string[] = [];

    public get fileNameRef(): HTMLInputElement {
        return this.$refs.fileName as HTMLInputElement;
    }

    public get regulationsPdfUrl(): string {
        const url = (window.$config && window.$config.messageTemplateRegulationsPdfUrl) || '';
        if (!url) {
            return '';
        }
        if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/')) {
            return url;
        }
        return '/' + url.replace(/^\/+/, '');
    }

    public openRegulationsPdf(event?: Event) {
        if (event) {
            event.preventDefault();
        }
        const url = this.regulationsPdfUrl;
        if (!url) {
            return;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    public get attachmentTooltip(): string {
        const pdfOnly = this.$t('shared.pdfFilesOnly').toString();
        const maxFiles = this.$t('shared.maxLicenseAttachments').toString();
        const max = this.$t('shared.maxFileSize3MB').toString();
        return [pdfOnly, maxFiles, max].join('\n');
    }

    public get visibleAttachments(): AttachmentModel[] {
        return (this.model.senderRequestAttachments || []).filter((a) => !a.isDeleted);
    }

    public get canUploadMoreLicenseAttachments(): boolean {
        return this.visibleAttachments.length < this.maxLicenseAttachments;
    }

    public get canAddAttachment(): boolean {
        return this.canUploadMoreLicenseAttachments && this.selectedFileName !== '';
    }

    public get organizationName(): string {
        return this.model.clientName || '';
    }

    public get filteredSuggestedTemplates(): SuggestedTemplateModel[] {
        if (!this.model.classification) {
            return [];
        }
        return this.preApprovedTemplates;
    }

    public get isSuggestedFreeContentSelected(): boolean {
        return !!this.model.preApprovedTemplateId;
    }

    public get templateContentCharacterCount(): number {
        return this.getTemplateContentWithoutVariables(this.model.templateContent).length;
    }

    public get templateContentCharactersRemaining(): number {
        return this.maxTemplateContentLength - this.organizationName.length - this.templateContentCharacterCount;
    }

    public get areVariableActionsDisabled(): boolean {
        return this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit;
    }

    public get fullTemplateContent(): string {
        const base = (this.model.templateContent || '').trim();
        if (this.isSuggestedFreeContentSelected) {
            return base;
        }
        const orgName = this.organizationName;
        if (!orgName) {
            return base;
        }
        if (base.toLowerCase().endsWith(orgName.toLowerCase())) {
            return base;
        }
        return base ? `${base} ${orgName}` : orgName;
    }

    public get substitutedFullContent(): string {
        const base = (this.model.templateContent || '').trim();
        let result = base;
        for (let i = 0; i < this.templateVariableExamples.length; i++) {
            const value = this.templateVariableExamples[i];
            if (value && value.trim()) {
                result = result.replace(new RegExp('#Var' + (i + 1) + '#', 'g'), value.trim());
            }
        }
        return result;
    }

    public get baseTemplateContent(): string {
        return (this.model.templateContent || '').trim();
    }

    public get hasTemplateVariables(): boolean {
        return /#Var\d+#/i.test(this.baseTemplateContent);
    }

    public get reviewTemplateVariables(): Array<{ key: string, value: string }> {
        return this.templateVariableExamples.map((example, index) => ({
            key: '#Var' + (index + 1) + '#',
            value: example || '',
        }));
    }

    public get areVariableExamplesValid(): boolean {
        if (!this.templateVariableExamples.length) {
            return true;
        }
        return this.templateVariableExamples.every((value) => value && value.trim() !== '');
    }

    public get isTemplateDescriptionValid(): boolean {
        const description = (this.model.templateDescription || '').trim();
        if (!description) {
            return true;
        }
        return description.length >= 3 && description.length <= 160;
    }

    public get templateDescriptionError(): string {
        const description = (this.model.templateDescription || '').trim();
        if (!description) {
            return '';
        }
        if (description.length < 3) {
            return this.$t('shared.templateDescriptionMinLength').toString();
        }
        if (description.length > 160) {
            return this.$t('shared.templateDescriptionMaxLength').toString();
        }
        return '';
    }

    public get filteredClassifications(): DropdownModel[] {
        let items: DropdownModel[] = this.allClassifications;
        if (this.senderType.length) {
            const allowedIds = new Set<number>();
            this.senderType.forEach((type) => {
                (this.classificationBySenderType[type] || []).forEach((id) => allowedIds.add(id));
            });
            items = this.allClassifications.filter((item) => allowedIds.has(item.id));
        }
        const currentId = this.normalizeClassification(this.model.classification);
        if (currentId && !items.some((item) => item.id === currentId)) {
            const fromAll = this.allClassifications.find((item) => item.id === currentId);
            if (fromAll) {
                items = items.concat([fromAll]);
            } else {
                items = items.concat([{
                    id: currentId,
                    name: this.getClassificationText(currentId),
                }]);
            }
        }
        return items;
    }

    public get templateContentMinimumCharacterCount(): number {
        return this.organizationName.length;
    }

    public get templateContentTotalCharacterCount(): number {
        return this.getTemplateContentWithoutVariables(this.fullTemplateContent).length;
    }

    public get hasInvalidVariableBoundary(): boolean {
        return this.contentStartsOrEndsWithVariable(this.model.templateContent);
    }

    public get isExpressProcessingDisabled(): boolean {
        return !window.$config
            || window.$config.messageTemplateSpeedUpApprovalDisabled !== false;
    }

    public get isProviderEditRole(): boolean {
        return this.userRole === 2 || this.userRole === 5;
    }

    public get isPlatformEditRole(): boolean {
        return this.userRole === 1 || this.userRole === 9 || this.userRole === 15;
    }

    public get isPendingPaymentEdit(): boolean {
        return this.isProviderEditRole && this.requestStatus === 7;
    }

    public get isRejectedEdit(): boolean {
        return this.isProviderEditRole && this.requestStatus === 3;
    }

    public get isCompletedEdit(): boolean {
        return this.isPlatformEditRole && this.requestStatus === 8;
    }

    public get isAttachmentsOnlyEdit(): boolean {
        return this.isCompletedEdit;
    }

    public get isProcessingDurationDisabled(): boolean {
        return !this.isRejectedEdit || this.isSuggestedFreeContentSelected || this.isExpressProcessingDisabled;
    }

    public get isClassificationDisabled(): boolean {
        return !this.isRejectedEdit || this.isAttachmentsOnlyEdit;
    }

    public get isTemplateDataDisabled(): boolean {
        return this.isAttachmentsOnlyEdit || this.isSuggestedFreeContentSelected;
    }

    private get canSafelyReloadSuggestedFreeContent(): boolean {
        return !this.isClassificationDisabled && !!this.model.classification;
    }

    private contentStartsOrEndsWithVariable(content: string): boolean {
        const trimmed = (content || '').trim();
        if (!trimmed) {
            return false;
        }
        return /^#Var\d+#/i.test(trimmed) || /#Var\d+#$/i.test(trimmed);
    }

    public isSuggestedTemplateSelected(template: SuggestedTemplateModel): boolean {
        if (!this.isSuggestedFreeContentSelected || !this.model.selectedTemplateId) {
            return false;
        }
        return String(this.model.selectedTemplateId) === String(template.id);
    }

    public get isSuggestedTemplateSelectionDisabled(): boolean {
        return this.isAttachmentsOnlyEdit;
    }

    public async created() {
        this.$emit('childinit', this.layoutSup);
        const user = await this.userService.getUser();
        this.userRole = this.userRoleService.GetUserRole(user);
        const providerId = user.details.ProviderId;
        const provider = await this.providerService.GetById(providerId);
        if (!provider.hasInternational) {
            this.customerTypeList.splice(3, 1);
        }
        this.isVipPackage = !!(window.$config && window.$config.messageTemplateVipPackage === true);
        const response = await this.UpdateContractRequestService.get(this.id);
        if (response.isSuccess) {
            const result = response.result || {};
            const rawPreApproved = result.preApprovedTemplateId || result.PreApprovedTemplateId || '';
            const preApprovedTemplateId = this.normalizePreApprovedTemplateId(rawPreApproved);
            const attachmentsRaw = result.senderRequestAttachments || result.SenderRequestAttachments || [];
            const processingDuration = result.processingDurationType != null
                ? result.processingDurationType
                : (result.ProcessingDurationType != null
                    ? result.ProcessingDurationType
                    : (result.processingDuration != null ? result.processingDuration : 1));
            const classification = this.normalizeClassification(
                result.classification != null ? result.classification : result.Classification,
            );
            const senderType = this.normalizeSenderTypeFlags(
                result.senderType != null ? result.senderType : result.SenderType,
            );
            this.model = {
                ...this.model,
                ...result,
                classification,
                senderType,
                preApprovedTemplateId,
                selectedTemplateId: result.selectedTemplateId || preApprovedTemplateId || '',
                processingDuration: Number(processingDuration) || 1,
                senderRequestAttachments: attachmentsRaw.map((a: any) => ({
                    id: a.id || a.Id || '',
                    fileName: a.fileName || a.FileName || '',
                    fileContent: a.fileContent || a.FileContent || '',
                    file: null,
                    attachmentType: a.attachmentType || a.AttachmentType || AttachmentCategoryType.Other,
                    attachmentTypeName: a.attachmentTypeName || a.AttachmentTypeName || this.$t('shared.licensesAndApproval').toString(),
                    isDeleted: false,
                })),
            };
            this.requestStatus = Number(result.requestStatus || result.RequestStatus || 0);
            this.model.isNormalProcessing = this.model.processingDuration == 1;
            this.model.isExpressProcessing = this.model.processingDuration == 2;
            this.model.templateExpiry = this.model.duration;
            this.getSenderType();
            this.concatenatedSenderTypes = this.senderType.map(type => this.getSenderTypeText(type)).join(', ');
            let parsedVariables: string[] | undefined;
            if (this.model.templateContent) {
                try {
                    const parsed = JSON.parse(this.model.templateContent);
                    if (parsed && typeof parsed.text === 'string') {
                        parsedVariables = parsed.variables;
                        this.model.templateContent = this.stripOrganizationNameSuffix(parsed.text);
                    }
                } catch {
                    this.model.templateContent = this.stripOrganizationNameSuffix(this.model.templateContent);
                }
            }
            this.syncVariablesFromTemplateContent(this.model.templateContent, parsedVariables);
            await this.loadPreApprovedTemplates(this.model.classification);
            this.syncSelectedSuggestedTemplateVisualState();
            this.captureSuggestedFreeContentSnapshot();
        } else {
            Toaster.error(response.errorMessage);
        }
    }

    public async next() {
        if (this.stepNumber === 1) {
            if (!this.validateTemplateInfoStep()) {
                return;
            }
            this.prepareTemplateInfoForNextStep();
            if (this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit) {
                this.isAiValid = true;
                this.aiValidationRemarks = '';
                this.stepNumber = 2;
                return;
            }
            const isValid = await this.runAiValidation();
            if (isValid) {
                this.stepNumber = 2;
            }
            return;
        }
        if (this.stepNumber < this.totalSteps) {
            this.stepNumber = this.stepNumber + 1;
        }
    }

    public back() {
        if (this.stepNumber === 2 && (this.isSuggestedFreeContentSelected || this.isAttachmentsOnlyEdit)) {
            this.stepNumber = 1;
            return;
        }
        if (this.stepNumber === 2) {
            this.resetTemplateCheck();
        }
        this.stepNumber = this.stepNumber - 1;
    }

    public cancel() {
        this.$router.push('/MessageTemplateDashboard');
    }

    public validateTemplateInfoStep(): boolean {
        if (!this.model.templateName.trim()) {
            Toaster.error(this.$t('shared.templateName').toString() + ' is required');
            return false;
        }
        if (!this.isTemplateDescriptionValid) {
            Toaster.error(this.templateDescriptionError);
            return false;
        }
        if (!this.model.classification) {
            Toaster.error(this.$t('shared.classification').toString() + ' is required');
            return false;
        }
        if (this.isSuggestedFreeContentSelected && !this.model.selectedTemplateId) {
            Toaster.error(this.$t('shared.selectSuggestedFreeTemplate').toString());
            return false;
        }
        if (!this.areVariableExamplesValid) {
            Toaster.error(this.$t('shared.variableExamplesRequired').toString());
            return false;
        }
        if (!this.isSuggestedFreeContentSelected && !this.model.templateContent.trim()) {
            Toaster.error(this.$t('shared.templateValue').toString() + ' is required');
            return false;
        }
        if (!this.isSuggestedFreeContentSelected
            && this.templateContentTotalCharacterCount < this.templateContentMinimumCharacterCount) {
            Toaster.error(this.$t('shared.templateCharacterCount', {
                count: this.templateContentTotalCharacterCount,
                min: this.templateContentMinimumCharacterCount,
            }).toString());
            return false;
        }
        if (!this.isSuggestedFreeContentSelected && this.hasInvalidVariableBoundary) {
            Toaster.error(this.$t('shared.templateVariableBoundaryInvalid').toString());
            return false;
        }
        return true;
    }

    private prepareTemplateInfoForNextStep() {
        const currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() + (this.model.templateExpiry || 1));
        this.model.expiryDate = currentDate.toISOString().split('T')[0];
        this.model.isNormalProcessing = !this.model.isExpressProcessing;
    }

    private getTemplateContentWithoutVariables(content: string): string {
        return (content || '').replace(/#Var\d+#/gi, '');
    }

    public selectedTemplateDescription: string = '';

    public get isDescriptionDisabled(): boolean {
        return this.isSuggestedFreeContentSelected && !!this.selectedTemplateDescription;
    }

    public selectSuggestedTemplate(template: SuggestedTemplateModel) {
        this.$set(this.model, 'preApprovedTemplateId', template.id);
        this.$set(this.model, 'selectedTemplateId', template.id);
        this.model.templateName = template.name;
        this.selectedTemplateDescription = template.description || '';
        this.model.templateDescription = template.description || '';
        this.model.templateContent = template.content;
        this.syncVariablesFromTemplateContent(template.content, template.variableExamples);
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    public deselectSuggestedTemplate() {
        this.$set(this.model, 'preApprovedTemplateId', '');
        this.$set(this.model, 'selectedTemplateId', '');
        this.model.templateName = '';
        this.selectedTemplateDescription = '';
        this.model.templateDescription = '';
        this.model.templateContent = '';
        this.templateVariableExamples = [];
        this.aiValidationRemarks = '';
        this.resetTemplateCheck();
    }

    private syncSelectedSuggestedTemplateVisualState() {
        const preApprovedId = this.model.preApprovedTemplateId || '';
        if (!preApprovedId) {
            this.$set(this.model, 'selectedTemplateId', '');
            this.selectedTemplateDescription = '';
            return;
        }
        this.$set(this.model, 'selectedTemplateId', preApprovedId);
        this.ensureSelectedSuggestedTemplateVisible();
        const matched = this.preApprovedTemplates.find(
            (template) => String(template.id) === String(preApprovedId),
        );
        if (matched) {
            this.selectedTemplateDescription = matched.description || '';
        }
    }

    private ensureSelectedSuggestedTemplateVisible() {
        const selectedId = this.model.preApprovedTemplateId || '';
        if (!selectedId) {
            return;
        }
        const exists = this.preApprovedTemplates.some(
            (template) => String(template.id) === String(selectedId),
        );
        if (exists) {
            return;
        }
        // Keep the existing selection visible when the template/classification
        // is no longer active and therefore absent from the API list.
        const selectedTemplate: SuggestedTemplateModel = {
            id: selectedId,
            templateCode: '',
            classification: this.model.classification,
            name: this.model.templateName || selectedId,
            description: this.model.templateDescription || '',
            content: this.model.templateContent || '',
            variableExamples: this.templateVariableExamples.slice(),
        };
        this.preApprovedTemplates = [selectedTemplate].concat(this.preApprovedTemplates);
    }

    private captureSuggestedFreeContentSnapshot() {
        const preApprovedTemplateId = this.model.preApprovedTemplateId || '';
        if (!preApprovedTemplateId) {
            this.loadedSuggestedFreeContentSnapshot = null;
            return;
        }
        this.loadedSuggestedFreeContentSnapshot = {
            preApprovedTemplateId,
            selectedTemplateId: this.model.selectedTemplateId || preApprovedTemplateId,
            templateContent: this.model.templateContent || '',
            templateDescription: this.model.templateDescription || '',
            templateName: this.model.templateName || '',
            templateVariableExamples: this.templateVariableExamples.slice(),
            selectedTemplateDescription: this.selectedTemplateDescription || '',
        };
    }

    public toggleSuggestedTemplate(template: SuggestedTemplateModel) {
        if (this.isSuggestedTemplateSelectionDisabled) {
            return;
        }
        if (this.isSuggestedTemplateSelected(template)) {
            this.deselectSuggestedTemplate();
            return;
        }
        this.selectSuggestedTemplate(template);
    }

    private syncVariablesFromTemplateContent(content: string, examples?: string[]) {
        const matches = [...(content || '').matchAll(/#Var(\d+)#/gi)];
        if (!matches.length) {
            this.templateVariableExamples = [];
            return;
        }
        const maxIndex = Math.max(...matches.map((match) => parseInt(match[1], 10)));
        this.templateVariableExamples = Array.from({ length: maxIndex }, (_, index) => {
            const provided = examples && examples[index];
            if (provided && provided.trim()) {
                return provided.trim();
            }
            return this.getDefaultVariableExampleValue(index + 1);
        });
    }

    private getDefaultVariableExampleValue(index: number): string {
        const defaults: { [key: number]: string } = {
            1: 'Customer',
            2: '123456',
            3: 'support@company.com',
        };
        return defaults[index] || `Var${index}Example`;
    }

    public addVariable() {
        if (this.areVariableActionsDisabled) {
            return;
        }
        const nextIndex = this.templateVariableExamples.length + 1;
        const textarea = this.$refs.templateContent as HTMLTextAreaElement;
        const cursorPos = textarea ? textarea.selectionStart : (this.model.templateContent || '').length;
        const content = this.model.templateContent || '';
        const before = content.substring(0, cursorPos);
        const after = content.substring(cursorPos);
        this.model.templateContent = `${before}#Var${nextIndex}#${after}`;
        this.ensureVariableExampleCount(nextIndex);
        this.$nextTick(() => {
            if (textarea) {
                const newCursorPos = cursorPos + `#Var${nextIndex}#`.length;
                textarea.setSelectionRange(newCursorPos, newCursorPos);
            }
        });
    }

    public deleteVariable(index: number) {
        if (this.areVariableActionsDisabled) {
            return;
        }
        this.templateVariableExamples.splice(index - 1, 1);
        let content = this.model.templateContent || '';
        content = content.replace(new RegExp(`#Var${index}#`, 'gi'), '');
        const currentMax = this.templateVariableExamples.length + 1;
        for (let i = index + 1; i <= currentMax; i++) {
            content = content.replace(new RegExp(`#Var${i}#`, 'gi'), `#Var${i - 1}#`);
        }
        this.model.templateContent = content;
    }

    public setVariableExample(index: number, value: string) {
        this.ensureVariableExampleCount(index);
        this.$set(this.templateVariableExamples, index - 1, value);
    }

    private ensureVariableExampleCount(index: number) {
        while (this.templateVariableExamples.length < index) {
            this.templateVariableExamples.push('');
        }
    }

    public onPickFile() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        (this.$refs.fileName as HTMLInputElement).click();
    }

    private isPdfFile(file: File): boolean {
        return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    }

    public onFilePicked(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = input.files;
        if (!files || !files.length) {
            return;
        }
        const file = files[0];
        if (!this.isPdfFile(file)) {
            Toaster.error(this.$t('shared.pdfFilesOnly').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        if (file.size > this.maxLicenseFileSizeBytes) {
            Toaster.error(this.$t('shared.fileSizeExceedsTheLimit').toString());
            input.value = '';
            this.selectedFileName = '';
            return;
        }
        this.selectedFileName = file.name;
        this.currentAttachment.file = file;
        const reader = new FileReader();
        reader.onloadend = (fileData: ProgressEvent<FileReader>) => {
            const result = fileData.target && fileData.target.result;
            if (typeof result === 'string') {
                this.currentAttachment.fileContent = result.split(',')[1];
                this.currentAttachment.fileName = file.name;
            }
        };
        reader.readAsDataURL(file);
        input.value = '';
    }

    public addAttachment() {
        if (!this.canUploadMoreLicenseAttachments) {
            Toaster.error(this.$t('shared.maxLicenseAttachments').toString());
            return;
        }
        this.currentAttachment.attachmentType = AttachmentCategoryType.Other;
        this.currentAttachment.attachmentTypeName = this.$t('shared.licensesAndApproval').toString();
        this.model.senderRequestAttachments.push({ ...this.currentAttachment });
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.selectedFileName = '';
        if (this.fileNameRef) {
            this.fileNameRef.value = '';
        }
    }

    public deleteAttachment(index: number) {
        const visible = this.visibleAttachments;
        const attachment = visible[index];
        if (!attachment) {
            return;
        }
        if (attachment.id) {
            this.$set(attachment, 'isDeleted', true);
            return;
        }
        const realIndex = this.model.senderRequestAttachments.indexOf(attachment);
        if (realIndex >= 0) {
            this.model.senderRequestAttachments.splice(realIndex, 1);
        }
    }

    private stripOrganizationNameSuffix(content: string): string {
        const orgName = (this.model.clientName || '').trim();
        const trimmed = (content || '').trim();
        if (!orgName || !trimmed) {
            return trimmed;
        }
        const suffixWithSpace = ' ' + orgName;
        if (trimmed.toLowerCase().endsWith(suffixWithSpace.toLowerCase())) {
            return trimmed.slice(0, trimmed.length - suffixWithSpace.length).trimEnd();
        }
        if (trimmed.toLowerCase().endsWith(orgName.toLowerCase())) {
            return trimmed.slice(0, trimmed.length - orgName.length).trimEnd();
        }
        return trimmed;
    }

    private resetTemplateCheck() {
        this.responseMessage = '';
        this.responseSuccess = false;
        this.isAiValid = false;
    }

    @Watch('model.customerType', { deep: true })
    public onchangeCustomerType() {
        switch (this.model.customerType) {
            case 1:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                    { id: SenderType.Warning, name: this.$t('shared.warning').toString() },
                ];
                this.senderName = '';
                break;
            case 2:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                ];
                this.senderName = '';
                break;
            case 3:
                this.senderTypeList = [
                    { id: SenderType.Advertisement, name: this.$t('shared.advertisement').toString() },
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                    { id: SenderType.Awareness, name: this.$t('shared.awareness').toString() },
                ];
                break;
            case 4:
                this.senderTypeList = [
                    { id: SenderType.Service, name: this.$t('shared.service').toString() },
                ];
                this.senderType = [SenderType.Service];
                break;
        }
    }

    @Watch('model.preApprovedTemplateId')
    public onSuggestedFreeContentChanged(isEnabled: boolean) {
        if (!isEnabled) {
            this.model.selectedTemplateId = '';
            this.model.templateContent = '';
            this.templateVariableExamples = [];
            this.aiValidationRemarks = '';
            this.resetTemplateCheck();
        }
    }

    @Watch('model.classification')
    public onClassificationChanged(newClassification: number, oldClassification: number) {
        if (this.isClassificationDisabled) {
            return;
        }
        if (oldClassification && newClassification !== oldClassification && this.isSuggestedFreeContentSelected) {
            this.deselectSuggestedTemplate();
        }
        this.loadPreApprovedTemplates(newClassification);
    }

    private async loadPreApprovedTemplates(classification: number) {
        if (!classification) {
            this.preApprovedTemplates = [];
            return;
        }
        this.loadingPreApprovedTemplates = true;
        try {
            const response = await this.messageTemplateService.getPreApprovedTemplates(classification);
            if (response && response.isSuccess && response.result) {
                this.preApprovedTemplates = (response.result || []).map((item: any) => {
                    let contentText = '';
                    let variables: string[] = [];
                    let rawContent = item.templateContent || item.TemplateContent || '';
                    if (rawContent) {
                        try {
                            let parsed = JSON.parse(rawContent);
                            contentText = parsed.text || rawContent;
                            variables = parsed.variables || [];
                        } catch {
                            contentText = rawContent;
                        }
                    }
                    return {
                        id: item.id || item.Id,
                        templateCode: item.templateCode || item.TemplateCode || '',
                        classification: item.classification || item.Classification,
                        name: item.name || item.Name,
                        description: item.description || item.Description || '',
                        content: contentText,
                        variableExamples: variables,
                    };
                });
            } else {
                this.preApprovedTemplates = [];
            }
        } catch {
            this.preApprovedTemplates = [];
        } finally {
            this.loadingPreApprovedTemplates = false;
            this.syncSelectedSuggestedTemplateVisualState();
        }
    }

    public showsubmitRequestDialog() {
        this.submitRequestdialog = true;
    }

    public hidesubmitRequestDialog() {
        this.submitRequestdialog = false;
    }

    public async submitRequest() {
        const preApprovedTemplateId = this.normalizePreApprovedTemplateId(this.model.preApprovedTemplateId);
        const payload = {
            Id: this.model.id,
            TemplateName: this.model.templateName,
            TemplateDescription: this.model.templateDescription || '',
            TemplateContent: JSON.stringify({
                text: this.fullTemplateContent,
                variables: this.templateVariableExamples,
            }),
            SenderId: this.model.senderId,
            IsExpressProcessing: this.model.isExpressProcessing,
            ExpiryDate: this.model.expiryDate || null,
            Classification: this.normalizeClassification(this.model.classification) || null,
            PreApprovedTemplateId: preApprovedTemplateId || null,
            SenderRequestAttachments: (this.model.senderRequestAttachments || []).map((attachment) => ({
                Id: attachment.id || null,
                FileName: attachment.fileName,
                FileContent: attachment.fileContent || null,
                AttachmentType: attachment.attachmentType || AttachmentCategoryType.Other,
                IsDeleted: !!attachment.isDeleted,
            })),
        };
        const response = await this.UpdateContractRequestService.post(payload as any);
        if (response && response.isSuccess) {
            this.isSubmitted = true;
        } else {
            Toaster.error((response && response.errorMessage) || this.$t('shared.errorOccurred').toString());
        }
        this.hidesubmitRequestDialog();
    }

    public newRequest() {
        this.reset();
        this.stepNumber = 1;
    }

    public select(event: any, id: string) {
        if (!event) {
            const index = this.selectedIds.indexOf(id);
            this.selectedIds.splice(index, 1);
        } else {
            this.selectedIds.push(id);
        }
    }

    public getCustomerTypeText(typeId: number) {
        switch (typeId) {
            case 1: return this.$t('shared.government').toString();
            case 2: return this.$t('shared.charity').toString();
            case 3: return this.$t('shared.private').toString();
            case 4: return this.$t('shared.international').toString();
            default: return '-';
        }
    }

    public getClassificationText(typeId: number) {
        const normalizedId = this.normalizeClassification(typeId);
        const item = this.allClassifications.find((c) => c.id === normalizedId);
        if (item) {
            return item.name;
        }
        if (normalizedId === 4) {
            return 'Verification';
        }
        return normalizedId ? String(normalizedId) : '-';
    }

    private normalizeClassification(value: any): number {
        if (value === null || value === undefined || value === '') {
            return 0;
        }
        const asNumber = Number(value);
        if (!isNaN(asNumber) && asNumber > 0) {
            return asNumber;
        }
        const key = String(value).trim().toLowerCase();
        if (key === 'advertising') { return 1; }
        if (key === 'service') { return 2; }
        if (key === 'warning') { return 3; }
        if (key === 'verification') { return 4; }
        if (key === 'awareness') { return 5; }
        return 0;
    }

    private normalizeSenderTypeFlags(value: any): number {
        if (value === null || value === undefined || value === '') {
            return 0;
        }
        const asNumber = Number(value);
        if (!isNaN(asNumber) && asNumber > 0) {
            return asNumber;
        }
        const key = String(value).trim().toLowerCase();
        if (key === 'advertisement') { return SenderType.Advertisement; }
        if (key === 'service') { return SenderType.Service; }
        if (key === 'awareness') { return SenderType.Awareness; }
        if (key === 'warning') { return SenderType.Warning; }
        return 0;
    }

    private normalizePreApprovedTemplateId(value: any): string {
        if (value === null || value === undefined || value === '') {
            return '';
        }
        const id = String(value);
        if (id === '00000000-0000-0000-0000-000000000000') {
            return '';
        }
        return id;
    }

    public getSenderType() {
        this.senderType = [];
        const senderBinary = this.normalizeSenderTypeFlags(this.model.senderType);
        if ((senderBinary & 1) === 1) {
            this.senderType.push(1);
        }
        if ((senderBinary & 2) === 2) {
            this.senderType.push(2);
        }
        if ((senderBinary & 4) === 4) {
            this.senderType.push(4);
        }
        if ((senderBinary & 8) === 8) {
            this.senderType.push(8);
        }
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement: return this.$t('shared.advertisement').toString();
            case SenderType.Service: return this.$t('shared.service').toString();
            case SenderType.Awareness: return this.$t('shared.awareness').toString();
            case SenderType.Warning: return this.$t('shared.warning').toString();
            default: return '-';
        }
    }

    private getTemplateValidationErrorMessage(response: any, axiosError?: AxiosError): string {
        const responseReason = response && response.result ? response.result.reason : '';
        const responseErrorMessage = response ? (response.errorMessage || response.ErrorMessage || '') : '';
        const apiErrorData: any = axiosError && axiosError.response ? axiosError.response.data : null;
        const apiErrorMessage = apiErrorData ? (apiErrorData.errorMessage || apiErrorData.ErrorMessage || apiErrorData.message || '') : '';
        const rawMessage = (responseReason || responseErrorMessage || apiErrorMessage || '').toString();
        if (!rawMessage) {
            return this.$t('shared.errorOccurred').toString();
        }
        if (rawMessage.toLowerCase().indexOf(this.noActiveRegulationMessage.toLowerCase()) !== -1) {
            return this.$t('shared.noActiveRegulationFoundForThisCategory').toString();
        }
        return rawMessage;
    }

    private startAiValidationLoading(): void {
        this.loadingAIValidation = true;
        this.aiValidationProgress = 0;
        clearInterval(this.aiValidationProgressInterval);
        this.aiValidationProgressInterval = setInterval(() => {
            if (this.aiValidationProgress < 98) {
                this.aiValidationProgress += 1;
            }
        }, 300);
    }

    private endAiValidationLoading(forceTo100: boolean): void {
        clearInterval(this.aiValidationProgressInterval);
        if (forceTo100) {
            this.aiValidationProgress = 100;
        }
        this.loadingAIValidation = false;
    }

    private async runAiValidation(): Promise<boolean> {
        this.startAiValidationLoading();
        try {
            return await this.checkMessageTemplate();
        } finally {
            this.endAiValidationLoading(true);
        }
    }

    async checkMessageTemplate(): Promise<boolean> {
        this.responseMessage = '';
        this.responseSuccess = false;
        this.isAiValid = false;
        this.aiValidationRemarks = '';
        try {
            this.validationModel.TemplateContent = (this.model.templateContent || '').trim();
            this.validationModel.Classification = this.model.classification;
            const response = await this.messageTemplateService.checkMessageTemplate(this.validationModel);
            if (response.isSuccess) {
                if (response.result.valid === true) {
                    this.responseSuccess = true;
                    this.isAiValid = true;
                    this.aiValidationRemarks = '';
                    Toaster.success(this.$t('shared.templateValid').toString());
                    return true;
                } else {
                    this.responseSuccess = false;
                    this.isAiValid = false;
                    this.responseMessage = response.result.reason;
                    this.aiValidationRemarks = response.result.reason
                        || this.$t('shared.templateInvalid').toString();
                    Toaster.error(this.$t('shared.aiCheckFailed').toString());
                    return false;
                }
            } else {
                this.responseSuccess = false;
                this.isAiValid = false;
                this.responseMessage = this.getTemplateValidationErrorMessage(response);
                this.aiValidationRemarks = this.responseMessage;
                Toaster.error(this.$t('shared.aiCheckFailed').toString());
                return false;
            }
        } catch (error) {
            const axiosError = error as AxiosError;
            this.responseSuccess = false;
            this.isAiValid = false;
            this.responseMessage = this.getTemplateValidationErrorMessage(null, axiosError);
            this.aiValidationRemarks = this.responseMessage;
            Toaster.error(this.$t('shared.aiCheckFailed').toString());
            return false;
        }
    }

    public get isValidStep(): boolean {
        if (this.stepNumber === 1) {
            const nameValid = this.model.templateName.trim() !== '';
            const expiryValid = this.model.templateExpiry !== 0;
            if (this.isSuggestedFreeContentSelected) {
                return nameValid
                    && expiryValid
                    && !!this.model.selectedTemplateId
                    && this.areVariableExamplesValid;
            }
            return nameValid
                && expiryValid
                && this.model.templateContent.trim() !== ''
                && this.templateContentCharacterCount <= this.maxTemplateContentLength
                && this.areVariableExamplesValid;
        }
        return true;
    }

    public reset() {
        const snapshot = this.loadedSuggestedFreeContentSnapshot;
        const preserveSuggestedFreeContent = !this.canSafelyReloadSuggestedFreeContent
            && !!snapshot
            && !!snapshot.preApprovedTemplateId;

        this.model = {
            id: this.id,
            duration: '1',
            startDate: '',
            clientName: this.model.clientName,
            crNumber: this.model.crNumber,
            enterpriseUnifiedNumber: this.model.enterpriseUnifiedNumber,
            customerType: this.model.customerType,
            senderName: this.model.senderName,
            requestType: 7,
            comment: this.model.comment,
            expiryDate: '',
            senderType: this.model.senderType,
            isNormalProcessing: true,
            isExpressProcessing: false,
            preApprovedTemplateId: preserveSuggestedFreeContent && snapshot ? snapshot.preApprovedTemplateId : '',
            selectedTemplateId: preserveSuggestedFreeContent && snapshot ? snapshot.selectedTemplateId : '',
            senderId: this.model.senderId,
            templateContent: preserveSuggestedFreeContent && snapshot ? snapshot.templateContent : '',
            templateDescription: preserveSuggestedFreeContent && snapshot ? snapshot.templateDescription : '',
            templateExpiry: 0,
            templateName: preserveSuggestedFreeContent && snapshot ? snapshot.templateName : '',
            processingDuration: 0,
            classification: this.model.classification,
            chanel: this.model.chanel,
            senderRequestAttachments: [],
        };
        this.contractAttachmentName = '';
        this.senderType = [];
        this.getSenderType();
        if (preserveSuggestedFreeContent && snapshot) {
            this.templateVariableExamples = snapshot.templateVariableExamples.slice();
            this.selectedTemplateDescription = snapshot.selectedTemplateDescription;
            this.ensureSelectedSuggestedTemplateVisible();
            this.syncSelectedSuggestedTemplateVisualState();
        } else {
            this.templateVariableExamples = [];
            this.selectedTemplateDescription = '';
            this.preApprovedTemplates = [];
            if (this.model.classification) {
                this.loadPreApprovedTemplates(this.model.classification);
            }
        }
        this.selectedFileName = '';
        this.currentAttachment = {
            id: '',
            fileName: '',
            fileContent: '',
            file: null,
            attachmentType: '',
            attachmentTypeName: '',
            isDeleted: false,
        };
        this.aiValidationRemarks = '';
        this.isSubmitted = false;
        this.resetTemplateCheck();
    }
}
